import { Box, CircularProgress, Typography } from "@mui/material";

import { useGetProductFeaturesQuery } from "api/memberPortal/features/productFeatures/productFeatures.api";

import TestedFeatureList from "./TestedFeatureList";

interface TestedFeatureProps {
  featureType: "product" | "pcm";
  featureId: number;
  readOnly: boolean;
}

const TestedFeature = ({
  featureType,
  featureId,
  readOnly,
}: TestedFeatureProps) => {
  const {
    data: features,
    isLoading,
    error,
  } = useGetProductFeaturesQuery({
    ...(featureType === "product"
      ? { product_id: featureId }
      : { pcm_id: featureId }),
  });

  if (isLoading) {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">
          Error loading features. Please try again.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TestedFeatureList
        featureType={featureType}
        featureId={featureId}
        features={features || []}
        readOnly={readOnly}
      />
    </Box>
  );
};

export default TestedFeature;
